import React from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { sexualOrientation } from '../../config/constants/sexualOrientationConstants';

const SelectSexualOrientation = ({ value, onChange }) => {
  const options = Object.values(sexualOrientation);
  return <DropdownSelect options={options} value={value} onChange={onChange} />;
};

export default SelectSexualOrientation;

SelectSexualOrientation.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  onChange: PropTypes.func,
};
